<template>
    <div ref="no_bar"></div>
</template>

<script>
import NoBar from "!!raw-loader!../../assets/ricoh_assets/icons/ICN002-11_no_bar.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.no_bar.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = NoBar

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>
</style>